import { Spinner } from '@lili/lili-frontend-common';

export const GeneralSpinner = () => <Spinner width='32px' height='32px' />;
